// Seller-concession (interested-party contribution) limits + closing-cost buckets.

export function maxConcessionPct(loanType, downPct, occupancy) {
  const tokens = (loanType || "").toLowerCase().match(/[a-z]+/g) || [];
  if (tokens.includes("fha")) return 6;
  if (tokens.includes("va")) return 4;
  // Conventional (Fannie/Freddie)
  if ((occupancy || "primary").toLowerCase().includes("invest")) return 2;
  const dp = Number(downPct || 0);
  if (dp < 10) return 3;
  if (dp < 25) return 6;
  return 9;
}

const POINTS_KEYS = ["point", "discount"];
const LENDER_KEYS = [
  "origination", "orig fee", "processing", "underwriting", "application",
  "commitment", "admin", "doc prep", "document prep", "lender fee",
];
// Fees that are financed INTO the loan (not part of cash to close): VA funding fee, FHA upfront MIP.
const FINANCED_KEYS = [
  "va funding", "funding fee", "upfront mortgage insurance", "up front mortgage insurance",
  "up-front mortgage insurance", "ufmip", "upfront mip", "up front mip", "upfront mi premium",
];

export function isFinancedFee(label) {
  const l = (label || "").toLowerCase();
  return FINANCED_KEYS.some((k) => l.includes(k));
}

export function categorizeFee(label) {
  const l = (label || "").toLowerCase();
  if (isFinancedFee(l)) return "financed";
  if (POINTS_KEYS.some((k) => l.includes(k))) return "points";
  if (LENDER_KEYS.some((k) => l.includes(k))) return "lender";
  return "third_party";
}

// Categories offered in the lender's per-fee dropdown.
export const FEE_CATEGORIES = [
  { key: "lender", label: "Lender Fees" },
  { key: "third_party", label: "3rd-Party Costs" },
  { key: "points", label: "Market Cost of Rate" },
  { key: "financed", label: "Financed (rolled into loan)" },
];

// The four buckets, in display order. `prepaids` is sourced from prepaids_items.
export const BUCKETS = [
  { key: "lender", label: "Lender Fees", hint: "Origination & processing — the only fees your lender charges", highlight: true },
  { key: "third_party", label: "3rd-Party Costs", hint: "Standard on every loan — title, escrow, appraisal, recording, credit" },
  { key: "prepaids", label: "Prepaids", hint: "Homeowner's insurance & property taxes (escrows / prepaids)" },
  { key: "points", label: "Market Cost of Rate", hint: "Discount points for the rate the loan is floating at" },
];

export const OCCUPANCY_OPTIONS = [
  { value: "primary", label: "Primary residence" },
  { value: "second", label: "Second home" },
  { value: "investment", label: "Investment property" },
];
